import styled from 'styled-components';

export const FormField = styled.div`
	margin-bottom: 1rem;
`;

export const ButtonStyles = {
	display: 'flex',
	height: '2.5rem',
	padding: '0.5rem',
	justifyContent: 'center',
	alignItems: 'center',
	gap: '0.5rem',
	alignSelf: 'stretch',
};

export const disabledInputStyles = {
	input: {
		backgroundColor: '#f1f3f5',
	},
};

export const HelperText = styled.small`
	color: #777;
	margin-top: 0.25rem;
	display: block;
`;
